import { render, staticRenderFns } from "./OrderPortrayDetail.vue?vue&type=template&id=d9043870"
import script from "./OrderPortrayDetail.vue?vue&type=script&lang=js"
export * from "./OrderPortrayDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports